var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Canvas",
    transform: "translate(2305 1366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__piled-files"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#files_svg__files_svg__path0_fill",
    transform: "translate(-2305 -1355.51)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#files_svg__files_svg__path1_fill",
    transform: "translate(-2305 -1358.54)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#files_svg__files_svg__path2_fill",
    transform: "translate(-2305 -1361.58)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#files_svg__files_svg__path3_fill",
    transform: "translate(-2305 -1365.99)",
    fill: "#FFFFFF"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__files_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 0.000626919 2.16345C 0.012321 2.43621 0.202428 2.66945 0.469576 2.73955L 6.8666 4.41397C 7.01862 4.45366 7.17459 4.47331 7.32993 4.47331C 7.52953 4.47331 7.72844 4.44103 7.9191 4.37614L 16.5496 1.44293C 16.8168 1.35214 16.9906 1.0971 16.9749 0.818483C 16.9594 0.539724 16.7581 0.30531 16.4825 0.244L 15.3809 0L 8.29188 2.40948C 7.98162 2.515 7.65806 2.56848 7.3299 2.56848C 7.07504 2.56848 6.82073 2.53569 6.57306 2.47103L 1.5337 1.15193L 0.417563 1.54917C 0.157711 1.64169 -0.0116606 1.89069 0.000626919 2.16345Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__files_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 0.000626919 2.16348C 0.012321 2.43624 0.202986 2.66959 0.470099 2.73966L 6.86657 4.414C 7.01859 4.45379 7.17456 4.47366 7.3299 4.47366C 7.5295 4.47366 7.7284 4.44107 7.91907 4.37621L 16.5496 1.44297C 16.8168 1.35217 16.9905 1.09707 16.9749 0.818552C 16.9593 0.53969 16.7581 0.30531 16.4825 0.244L 15.3808 0L 8.29184 2.40952C 7.98159 2.515 7.65803 2.56824 7.32986 2.56824C 7.075 2.56824 6.8207 2.53572 6.57303 2.4711L 1.5337 1.152L 0.417563 1.54928C 0.157711 1.64172 -0.0116606 1.89076 0.000626919 2.16348Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__files_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 8.29188 2.40921C 7.98162 2.51469 7.65806 2.56797 7.3299 2.56797C 7.07504 2.56797 6.82073 2.53541 6.57306 2.47079L 1.5337 1.152L 0.417563 1.54928C 0.157711 1.64176 -0.0116606 1.89079 0.000626919 2.16355C 0.012321 2.43624 0.202986 2.66955 0.470099 2.73966L 6.86657 4.41403C 7.01859 4.45376 7.17456 4.47341 7.3299 4.47341C 7.5295 4.47341 7.7284 4.4411 7.91907 4.37628L 16.5496 1.443C 16.8168 1.35217 16.9905 1.09707 16.9749 0.818552C 16.9593 0.539724 16.7581 0.305345 16.4825 0.244069L 15.3808 0L 8.29188 2.40921Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__files_svg__path3_fill",
    fillRule: "evenodd",
    d: "M 0.469576 4.11807L 6.8666 5.79245C 7.01862 5.83217 7.17459 5.85179 7.32993 5.85179C 7.52953 5.85179 7.72844 5.81948 7.9191 5.75462L 16.5496 2.82141C 16.8168 2.73055 16.9906 2.47552 16.9749 2.19697C 16.9594 1.9181 16.7581 1.68376 16.4825 1.62245L 9.35551 0.0433103C 9.22468 0.0143103 9.09172 0 8.95924 0C 8.75074 0 8.54342 0.0352759 8.3455 0.105724L 0.417563 2.92766C 0.157711 3.02014 -0.0116606 3.26917 0.000626919 3.54193C 0.012321 3.81469 0.202428 4.04793 0.469576 4.11807Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.e151f233198d97c88e6ce64a4fb96c3f.svg";
export { ForwardRef as ReactComponent };